module.exports = __webpack_public_path__ + "img/logo-small.5ba71e16.png";